import { useSearchParams } from 'react-router-dom';
import { WORKFLOW_ID_PARAM } from 'modules/candidate-profile/constants';

/**
 * The workflow a recruiter was handed over from in the builder, or null if they arrived
 * at Candidates the ordinary way.
 *
 * Its presence is what marks the visit as "populate this one workflow", which several
 * parts of the screen narrow themselves around — so they read it from here rather than
 * each reaching into the query string.
 */
export const usePreselectedWorkflowId = (): string | null => {
  const [searchParams] = useSearchParams();

  return searchParams.get(WORKFLOW_ID_PARAM);
};
